import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import { register } from "../slices/user";
import { useDispatch, useSelector } from "react-redux";
import { clearMessage, setMessage, setMessageStatus } from "../slices/messages";
import { useNavigate } from "react-router-dom";
import Swal from 'sweetalert2'
import MemberFamily from "./user/MemberFamily";
import { useTranslation } from "react-i18next";


const Register = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { t } = useTranslation();

    const { message } = useSelector((state) => state.message);
    const { Status } = useSelector((state) => state.auth);

    const [submitted, setSubmitted] = useState(0);
    const current_date = new Date().getFullYear();
    clearMessage()
    // useEffect(() => {
    //     dispatch(clearMessage());
    // }, [dispatch]);

    useEffect(() => {
        // if (Status == "Failed") {
        //     window.scrollTo(0, 0);
        // }
    }, [Status]);

    const firstitem = {
        type: "",
        name: "",
        dob: "",
    };
    const [items, setItems] = useState([firstitem]);

    const addRows = (e) => {
        const item = {
            type: "",
            name: "",
            dob: "",
        };
        setItems([...items, item]);
    }

    const removeRows = (idx) => {
        const tempItems = [...items]; // to avoid  direct state mutation
        tempItems.splice(idx, 1);
        setItems(tempItems);
    }

    const updateState = (e) => {
        let index = e.target.attributes.index.value; // index of state array -rows
        let fieldValue = e.target.value; // value
        let fieldnName = e.target.name; // value

        const tempRows = [...items]; // avoid direct state mutation
        const tempObj = items[index]; // copy state object at index to a temporary object
        tempObj[fieldnName] = fieldValue; // modify temporary object

        // return object to rows` clone
        tempRows[index] = tempObj;
        setItems(tempRows); // update state

    };

    const [inputValues, setInputValue] = useState({
        village: "",
        block: "",
        district: "",
        head_name: "",
        birth_year: "",
        phone_no: "",
        father_name: "",
        mother_name: "",
    });

    function handleChange(event) {
        const { name, value } = event.target;
        setInputValue({ ...inputValues, [name]: value });
        dispatch(clearMessage());
    }

    const handleRegister = (e) => {
        e.preventDefault();
        setSubmitted(1);
        // const village = inputValues;
        const newObj = Object.assign({ items: items }, inputValues);
        dispatch(register(newObj))
            .unwrap()
            .then(() => {
                dispatch(setMessageStatus('Success'));
                navigate('/login');
            })
            .catch(() => {
                setSubmitted(0);
                setTimeout(() => {
                    dispatch(clearMessage());
                  }, 3000)
                window.scrollTo(0, 0);
            });
    };

    return (
        <div className="container">
            <section className="mt-5 pt-5 gallery">
                <div className="card bg-2 login-card bg-primary-new register-card p-6">
                    <div className="card-body">
                        <div className='section-title text-center' id="heading_title">
                            <h1 className="mb-0"><span className='font-color-1'>{t('register')}</span></h1>
                        </div>
                        {(message && Status == "Failed") && (
                            <div className="col-md-12 error-section mt-2-5">
                                <div
                                    className="alert alert-warning"
                                    role="alert"
                                >
                                    {message}
                                </div>
                            </div>
                        )}
                        <form action="#" onSubmit={e => handleRegister(e)} method="post" autoComplete="off">
                            <div className="row mt-2-5">
                                <div className="col-md-6 form-group mb-1-5">
                                    <label>{t('village')}</label>
                                    <input type="text" className="form-control" placeholder={t('enter_village')} name="village" onChange={(e) => handleChange(e)} required />
                                </div>
                                <br />
                                <div className="col-md-6 form-group mb-1-5">
                                    <label>{t('block')}</label>
                                    <input type="text" className="form-control" placeholder={t('enter_block')} name="district" onChange={(e) => handleChange(e)} required />
                                </div>
                                <div className="col-md-6 form-group mb-1-5">
                                    <label>{t('district')}</label>
                                    <input type="text" className="form-control" placeholder={t('enter_district')} name="block" onChange={(e) => handleChange(e)} required />
                                </div>
                                <div className="col-md-12 form-group mb-1-5">
                                    <h5 className="signupInfo mb-0">{t('details_of_family_head')}</h5>
                                </div>
                                <div className="col-md-6 form-group mb-1-5">
                                    <label>{t('name_of_the_head')}</label>
                                    <input type="text" className="form-control" placeholder={t('enter_head_name')} name="head_name" onChange={(e) => handleChange(e)} required/>
                                </div>
                                <div className="col-md-6 form-group mb-1-5">
                                    <label>{t('birth_year')}</label>
                                    <input type="number" min="1949" max={current_date} step="1" className="form-control" placeholder={t('enter_dob')} name="birth_year" onChange={(e) => handleChange(e)} required />
                                </div>
                                <div className="col-md-6 form-group mb-1-5">
                                    <label>{t('phone_number')}</label>
                                    <input type="text" className="form-control" placeholder={t('enter_phone_number')} name="phone_number" onChange={(e) => handleChange(e)} required />
                                </div>
                                <div className="col-md-6 form-group mb-1-5">
                                    <label>{t('father_name')}</label>
                                    <input type="text" className="form-control" placeholder={t('enter_father_name')} name="father_name" onChange={(e) => handleChange(e)} required />
                                </div>
                                <div className="col-md-6 form-group mb-1-5">
                                    <label>{t('mother_name')}</label>
                                    <input type="text" className="form-control" placeholder={t('enter_mother_name')} name="mother_name" onChange={(e) => handleChange(e)} required  />
                                </div>
                                <div className="col-md-6 form-group mb-1-5">
                                    <label>{t('grandfather_name')}</label>
                                    <input type="text" className="form-control" placeholder={t('enter_gfather')} name="grand_father_name" onChange={(e) => handleChange(e)} required />
                                </div>
                                <div className="col-md-6 form-group mb-1-5">
                                    <label>{t('grandmother_name')}</label>
                                    <input type="text" className="form-control" placeholder={t('enter_gmother')} name="grand_mother_name" onChange={(e) => handleChange(e)} required />
                                </div>
                                <div className="col-md-6 form-group mb-1-5">
                                    <label>{t('cast')}</label>
                                    <input type="text" className="form-control" placeholder={t('enter_cast')} name="cast" onChange={(e) => handleChange(e)} autoComplete="off" required/>
                                </div>
                                <div className="col-md-6 form-group mb-1-5">
                                    <label>{t('education')}</label>
                                    <select className="form-control rightArrow" name="education" onChange={(e) => handleChange(e)} required>
                                        <option value="">{t('choose')}</option>
                                        <option value="Below Metric" >{t('belowMetric')} </option>
                                        <option value="Metric" >      {t('Metric')}      </option>
                                        <option value="Graduate">     {t('graduate')}    </option>
                                        <option value="Post Graduate">{t('postGraduate')}</option>
                                    </select>
                                </div>
                                <div className="col-md-6 form-group mb-1-5">
                                    <label>{t('marital_status')}</label>
                                    <select className="form-control rightArrow" name="marital_status" onChange={(e) => handleChange(e)} required>
                                        <option value="">{t('choose')}</option>
                                        <option value="Married">{t('married')}</option>
                                        <option value="UnMarried">{t('unMarried')}</option>
                                    </select>
                                </div>

                                {
                                    inputValues?.marital_status === "Married" &&
                                    <>
                                        <div className="col-md-12 form-group mb-1-5">
                                            <h5 className="signupInfo">{t('detail_son_doughter')}</h5>
                                        </div>

                                        <MemberFamily items={items} addRows={addRows} removeRows={removeRows} updateState={updateState} />
                                    </>
                                }

                                <div className="col-md-6 form-group mb-1-5">
                                    <label>{t('password')}</label>
                                    <input type="password" className="form-control" placeholder={t('enter_phone_password')} name="password" onChange={(e) => handleChange(e)} required />
                                </div>
                                <div className="form-group">
                                    {
                                        submitted ?
                                            <button className="btn btn-primary btn-block col-md-6 offset-3" disabled>{t('please_wait')}</button>
                                            :
                                            <button type="submit" className="btn btn-primary btn-block col-md-6 offset-3">{t('register')}</button>
                                    }
                                </div>
                                <br />
                                <br />
                                <br />
                                <p className="font-color text-center">{t('account_exist')} <Link to="/login" className="link-text mt-2">{t('login')}</Link></p>
                            </div>
                        </form>
                    </div>
                </div>
            </section>
        </div>
    );
}
export default Register;